import { useQuery } from '@tanstack/react-query';

import getSchedules from 'Api/schedule/getSchedules';

import { useScheduleState } from 'View/schedule/state';

import getScheduleRequest from './model/request/getScheduleRequest';
import getScheduleResponse from './model/response/getScheduleResponse';

const useGetSchedule = () => {
  const { filterState } = useScheduleState();

  return useQuery({
    queryKey: ['schedules', filterState],
    queryFn: async () => {
      const queries = getScheduleRequest(filterState);

      let response = await getSchedules({ queries });

      const result = getScheduleResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: 0,
    gcTime: 0,
  });
};

export default useGetSchedule;
